import React, { useContext, useRef } from 'react'
import "./style.css"
import HeaderName from '../../components/HeaderName'
import { useTranslation } from 'react-i18next'
import ActionBtn from '@/components/ActionBtn'
import { useNavigate } from 'react-router-dom'
import { PrivilegeContext } from '@/context/PrivilegesContext'
import { CRRender } from '@/components/crRender'
//import EmailTemplatePopup from '@/components/popups/EmailTemplatePopup'

const HomePage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const { userRoleId } = useContext(PrivilegeContext)

 /*    const emailTemplatePopupRef = useRef(null)


    const handleOpenEmailTemplatePopup = () => {
        emailTemplatePopupRef.current?.click()
    } */   

    return (

        <>
            <HeaderName PageName={t("Home")} />
            
         {/*   <div onClick={handleOpenEmailTemplatePopup}>Open Email Template Popup</div> */}
{/* 
            <EmailTemplatePopup modalID={emailTemplatePopupRef}  />
 */}
            <CRRender isRender={userRoleId == 4}>

                <ActionBtn className='submit-btn' title='edit-profile' onApply={() => navigate('/panel/provider-profile')} />
            </CRRender>
        </>
    )
}

export default HomePage